<template lang="pug">
v-container
  div.text-lg.font-medium.basic700--text {{ $t('cover_photo') }}
  div.text-sm.font-normal.basic600--text {{ $t('cover_photo_desc') }}

  div.text-md.font-medium.basic700--text.mt-6 {{ $t('embed_as') }}

  v-radio-group(v-model="mediaSelection")
    v-radio(value="image" color="basic700")
      template(v-slot:label)
        div.text-md.font-normal.basic700--text {{ $t('upload_photo') }}
    v-radio(value="video" color="basic700")
      template(v-slot:label)
        div.text-md.font-normal.basic700--text {{ $t('embed_video') }}

  v-form(ref="form")
    template(v-if="mediaSelection === 'image'")
      v-row(no-gutters align="center" v-if="resizeImageFileUrl")
        v-col(cols="12" sm="6")
          v-card(flat)
            div(align="center")
              v-img(:src="resizeImageFileUrl" contain)
                template(v-slot:placeholder)
                  v-row(class="fill-height ma-0" align="center" justify="center")
                    v-progress-circular(indeterminate color="grey")
        v-col(cols="12" sm="6" :align="isMobileScreen ? 'center' : ''")
          div.file-change-layout.ml-4
            v-btn.round-lg.text-md.font-bold.text-none.pl-5.pr-4.py-3(color="basic700" outlined depressed height="48")
              v-icon(left color="basic700") mdi-image-outline
              | {{ $t('change_image') }}
            input.input-change-layout(type="file" @change="onFileChange" accept="image/*" style="width: 157px !important")
      div.round-3xl.file-layout.py-8(v-else align="center")
        div.text-md.font-normal.info500--text
          v-icon.mb-1(color="info500" left size="22") $yzi-upload-01
          | {{ $t('upload_photo_10_mb') }}
        input.input-layout(type="file" @change="onFileChange" accept="image/*")
        
    template(v-if="mediaSelection === 'video'")
      v-row
        v-col(cols="12" sm="6")
          div.text-md.font-medium.basic700--text {{ $t('paste_video_url') }}
          div.text-sm.font-normal.basic600--text {{ $t('paste_video_url_desc') }}
          yc-text-field.mt-2(v-model="videoURL" :label="$t('video_url')" :rules="rules.valid_url")

  div.d-flex.mt-5
    v-spacer
    v-btn.round-lg.heading-6.px-8(color="info500" dark depressed height="48" :dark="!saveDisabled" :disabled="saveDisabled" :loading="isLoading" @click="saveData") {{ $t('save') }}
  
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { resizeImage } from '@/utils'

export default {
  name: 'DetailsCoverPhoto',
  data () {
    return {
      isLoading: false,
      mediaSelection: null,
      videoURL: null,
      resizeImageFileUrl: '',
      resizeImageFile: null,
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
        // valid_url: [v => !!v || 'Email is required', v => /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Invalid email address'],
        valid_url: [v => !!v || 'URL is required', v => /[(http(s)?):\\/\\/(www\\.)?a-zA-Z0-9@:%._\\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)/.test(v) || 'Invalid URL'],
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      campaign: 'donation/getCampaign'
    }),
    saveDisabled () {
      if (!this.mediaSelection) {
        return true
      } else if (this.mediaSelection === 'image') {
        if (!this.resizeImageFile) {
          return true
        }
      }
      return false
    },
    isMobileScreen() {
      return this.$vuetify.breakpoint.xs
    }
  },
  mounted () {
    if (this.campaign) {
      this.setData(this.campaign)
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    async onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      const resizedImage = await resizeImage(files[0], 'product_image.jpeg')
      this.resizeImageFileUrl = resizedImage.dataURL
      this.resizeImageFile = resizedImage.file
    },
    setData (campaign) {
      if (campaign.image) {
        this.resizeImageFileUrl = campaign.image.file
        this.videoURL = null
        this.mediaSelection = 'image'
      }
      if (campaign.video_link) {
        this.videoURL = campaign.video_link
        this.resizeImageFileUrl = null
        this.mediaSelection = 'video'
      }
    },
    saveData () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      var params = new FormData()
      if (this.mediaSelection === 'image' && this.resizeImageFile) {
        params.append('image', this.resizeImageFile)
        params.delete('video_link')
      } else if (this.mediaSelection === 'video' && this.videoURL) {
        params.append('video_link', this.sanitizeVideo(this.videoURL))
        params.delete('image')
      }
      this.$axios.patch(`/donations/${this.company.slug}/campaigns/${this.campaign.form.slug}`, params)
        .then(resp => {
          this.$store.commit('donation/setCampaign', resp.data)
          this.setData(resp.data)
          this.showMessage(['success', this.$t('success_message.successfully_updated')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    sanitizeVideo (link) {
      if (link.includes('youtu')) {
        const url = new URL(link)
        const path = url.pathname.split('/')
        let code = path[path.length - 1]
        if (url.searchParams.get('v')) {
          code = url.searchParams.get('v')
        }
        return 'https://www.youtube.com/embed/'+ code
      } else {
        return link
      }
    }
  }
}
</script>

<style scoped>
.file-layout {
  position: relative;
  cursor: pointer;
  border: var(--v-basic500) dashed 2px;
}
.input-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
  cursor: pointer;
}
.file-change-layout {
  position: relative;
}
.input-change-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>